import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './styles.module.css';
import { useEntitiesFulfillmentPlanProperty } from '../../../../../../../hooks/entities/selectors/fulfillment-plans';
import { useIsFulfillmentPlanTaxIdentifierUpdatable } from '../edit-tax-identifiers/hooks';

/**
 * @typedef {import('ui-components/components/button').ButtonClickHandler} ButtonClickHandler
 */

export const ReadOnlyRecipientTaxIdentifiersContent = memo(
  /**
   * @param {object} props
   * @param {string} props.fulfillmentPlanId - selected fulfillmentPlanId to show tax identifier value
   * @param {ButtonClickHandler} props.onEdit - callback to be executed when clicking on edit button
   * @returns {JSX.Element} The rendered ReadOnlyRecipientTaxIdentifiersContent
   */
  ({ fulfillmentPlanId, onEdit }) => {
    const recipientTaxIdentifiers = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'recipientTaxIdentifiers');
    const showEditAction = useIsFulfillmentPlanTaxIdentifierUpdatable(fulfillmentPlanId);

    return (
      <div className={style['content-wrapper']}>
        <Text
          className={style.counter}
          element='span'
          textType={TextType.Paragraph}
          value={
            <FormattedMessage {...messages.recipientTaxIdentifierLabelCounter} values={{ count: recipientTaxIdentifiers?.length || 0 }} />
          }
        />
        {showEditAction ? (
          <Button onClick={onEdit} theme='link'>
            {recipientTaxIdentifiers?.length > 0 ? (
              <FormattedMessage {...messages.recipientTaxIdentifierLabelEditButton} />
            ) : (
              <FormattedMessage {...messages.recipientTaxIdentifierLabelAddButton} />
            )}
          </Button>
        ) : null}
      </div>
    );
  },
);
